import * as strategy from 'ol/loadingstrategy'
import * as extents from 'ol/extent'
interface IStrategyManager {
  bbox: (extent: any, resolution: number) => extents.Extent[]
}

const StrategyManager = strategy as any as IStrategyManager

export {StrategyManager}
